// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"tabs-content__wrap--1mjx2","tabs":"tabs-content__tabs--zXwxa","tab":"tabs-content__tab--vHMa1","active":"tabs-content__active--2WofF"};